<template>
<transition name="slide-fade">
  <div class="content" v-if="show">
    <div class="mt-5">
      <b-container class="bv-example-row bv-example-row-flex-cols" :sendEmail="sendEmail">
        <b-row align-v="center" class="mt-5">
          <b-col cols="12" sm="12" md="12" lg="12">
            <h1>Contact</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" class="mb-4">
            <b-form @submit="onSubmit">
              <b-form-group class="textLeft" id="exampleInputGroup1"
                            label="Email address:" label-for="exampleInput1">
                <b-form-input id="exampleInput1"
                              type="email" v-model="form.email" required
                              placeholder="Enter email"
                ></b-form-input>
              </b-form-group>
              <b-form-group class="textLeft" id="exampleInputGroup2"
                            label="Your Name:" label-for="exampleInput2">
                <b-form-input id="exampleInput2"
                              type="text" v-model="form.name" required
                              placeholder="Enter name"
                ></b-form-input>
              </b-form-group>
              <b-form-group class="textLeft" id="exampleInputGroup2"
                            label="Your message:" label-for="exampleInput3">
                <b-form-textarea id="textarea1"
                     v-model="form.message"
                     placeholder="Enter message"
                     :rows="3"
                     :max-rows="6">
                </b-form-textarea>
              </b-form-group>
              <b-button type="submit" variant="primary" :onClick="sendEmail">Submit</b-button>
            </b-form>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-jumbotron header="Contact me" lead="You can contact with me for instance" >
              <p>Email: mikephotography@example.com</p>
              <hr class="my-4">
              <p>Phone: 608-333-666</p>
              <hr class="my-4">
              <b-row class="justify-content-md-center mb-5 cf">
              <b-col cols="2" sm="2" md="2" lg="2" v-for="item in media" :key="item.id">
                <a :href="item.url" :title="item.title"><img :src="item.imgWhite"><img class="top" :src="item.imgHover"></a>
              </b-col>
            </b-row>
            </b-jumbotron>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
 </transition> 
</template>

<script>
export default {
  data () {
    return {
      form: {
        email: '',
        name: '',
        message: ''
      },
      media: [
        { url: 'https://www.facebook.com/', title: 'facebook', imgWhite: require('../assets/img/fbWhite.png'), imgHover: require('../assets/img/fbHover.png') },
        { url: 'https://twitter.com/', title: 'tweeter', imgWhite: require('../assets/img/tweeterWhite.png'), imgHover: require('../assets/img/tweeterHover.png') },
        { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: require('../assets/img/googleWhite.png'), imgHover: require('../assets/img/googleHover.png') },
        { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: require('../assets/img/hexagonWhite.png'), imgHover: require('../assets/img/hexagonWhite.png') },
        { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: require('../assets/img/picsaWhite.png'), imgHover: require('../assets/img/pinterestHover.png') },
        { url: 'https://github.com/features', title: 'github', imgWhite: require('../assets/img/gitWhite.png'), imgHover: require('../assets/img/gitWhite.png') }
      ],
      show: true
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    sendEmail() {
      const url = 'http://192.168.7.5/server/mail.php'
     const data = {
     name: this.name,
     email: this.email,
     message: this.message
    }
    $.ajax({
      type: "POST",
      url: url,
      data: JSON.stringify(data),
      success: (data) => {
        console.log(data)
      },
      dataType: 'json'
    });
  }
} 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cf img {
    position:absolute;
    left:0;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
    background-color: #e9ecef;
  }

  .cf img.top:hover {
    opacity:0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(300px);
    opacity: 0;
  }

  h1 {
    color: #ffffff;
  }

  .separator {
    text-align: center;
    color: #e8e8e8;
  }
  .imgCentred {
    text-align: center!important;
    margin-bottom: 20px;
  }
  .textCentred {
    text-align: center!important;
  }
  .content {
     margin-top: 0px;
      margin-bottom: 50px;
    background-image:  url('../assets/img/image.jpg');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
    background-attachment: fixed;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .sign {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    font-style: italic;
    text-align: center;
    margin-top: 15px;
  }
  .textLeft {
    font-family: 'Raleway Medium', serif;
    font-size: 16px;
    margin-top: 10px;
    color: #ffffff;
    font-weight: bolder;
  }
  .card {
    border: 0px !important;
  }
  .galleryItem {
    margin-top: 10px;
    margin-right: 5px;
    margin-left: 5px;
    text-align: center;
    width: 273px;
  }
  @media only screen and (max-width: 320px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
  @media only screen and (max-width: 375px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
  @media only screen and (max-width: 425px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
  @media only screen and (max-width: 640px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
  @media only screen and (max-width: 768px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
  @media only screen and (max-width: 1024px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
  @media only screen and (max-width: 1440px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      background-size: 100% auto;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
   @media only screen and (max-width: 2560px) {
    .content {
      margin-bottom: 50px;
      background-color: #000000;
      background-size: 100% auto;
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue?6ebc7884